import request from '@/utils/request'
import APIS from '@/permissions/index'
// 分页查询回款记录
export function queryTotalStatistics (params) {
  return request({
    ...APIS['@dispenseflow/Query_TotalStatistics'],
    params
  })
}
export function querySubTotalStatistics (params) {
  return request({
    ...APIS['@dispenseflow/Query_SubTotalStatistics'],
    params
  })
}
export function queryYearStatistics (params) {
  return request({
    ...APIS['@dispenseflow/Query_YearStatistics'],
    params
  })
}
export function querySubYearStatistics (params) {
  return request({
    ...APIS['@dispenseflow/Query_SubYearStatistics'],
    params
  })
}

export function queryCouponsStatistics (params) {
  return request({
    ...APIS['@dispenseflow/Query_CouponsStatistics'],
    params
  })
}

export function querySubCouponsStatistics (params) {
  return request({
    ...APIS['@dispenseflow/Query_SubCouponsStatistics'],
    params
  })
}

export function exportCouponsStatistics (params) {
  const headers = {
    'Content-Type': 'application/octet-stream'
  }
  const responseType = 'arraybuffer'
  return request({
    ...APIS['@dispenseflow/Export_CouponsStatistics'],
    params,
    headers,
    responseType
  })
}

export function exportYearStatistics (params) {
  const headers = {
    'Content-Type': 'application/octet-stream'
  }
  const responseType = 'arraybuffer'
  return request({
    ...APIS['@dispenseflow/Export_YearStatistics'],
    params,
    headers,
    responseType
  })
}

export function exportTotalStatistics (params) {
  const headers = {
    'Content-Type': 'application/octet-stream'
  }
  const responseType = 'arraybuffer'
  return request({
    ...APIS['@dispenseflow/Export_TotalStatistics'],
    params,
    headers,
    responseType
  })
}
